export const getDayName = () => {
  return [
    {
      value: "0",
      Name: "Sunday",
    },
    {
      value: "1",
      Name: "Monday",
    },
    {
      value: "2",
      Name: "Tuesday",
    },
    {
      value: "3",
      Name: "Wednesday",
    },
    {
      value: "4",
      Name: "Thursday",
    },
    {
      value: "5",
      Name: "Friday",
    },
    {
      value: "6",
      Name: "Saturday",
    },
  ];
};
